function handleDarkColorSchemeChange(event: MediaQueryList|MediaQueryListEvent) {
    document.querySelector("html")?.classList.toggle("sl-theme-dark", event.matches);
}

export function setupShoelaceDarkMode () {
  const mediaQueryList = matchMedia('(prefers-color-scheme: dark)');
  mediaQueryList.addEventListener('change', handleDarkColorSchemeChange);
  handleDarkColorSchemeChange(mediaQueryList)
}